import "./BehaviorTraining.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import BehaviorTopics from "./sections/BehaviorTopics";
import BehaviorArticles from "./sections/BehaviorArticles";
import Footer from "@/reusable_sections/Footer";
export default function BehaviorTrainingPage() {
  return <div>
      <Header />
      <Intro />
      <BehaviorTopics />
      <BehaviorArticles />
      <Footer />
    </div>;
}